export default {
  arrives: 'Arrive le',
  journeyDuration: 'Durée du voyage',
}
